import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/behance-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M186.5 293C186.5 312.3 172.5 318.4 155.3 318.4H110.2V265.5H156.2C174.8 265.6 186.5 273.3 186.5 293zM178.8 210.7C178.8 193 165.1 188.8 149.9 188.8H110.3V233.6H153C168.1 233.6 178.8 227 178.8 210.7zM311.1 233.9C292.8 233.9 280.6 245.3 279.4 263.6H341.6C339.9 245.1 330.3 233.9 311.1 233.9zM448 80V432C448 458.5 426.5 480 400 480H48C21.5 480 0 458.5 0 432V80C0 53.5 21.5 32 48 32H400C426.5 32 448 53.5 448 80zM271.7 185H349.5V166.1H271.7V185zM228.7 295.3C228.7 271.2 217.3 250.4 193.7 243.7 210.9 235.5 219.9 226 219.9 206.7 219.9 168.5 191.4 159.2 158.5 159.2H68V351.2H161.1C196 351 228.7 334.3 228.7 295.3zM380 280.5C380 239.4 355.9 205.1 312.4 205.1 270 205.1 241.3 236.9 241.3 278.7 241.3 322 268.6 351.7 312.4 351.7 345.6 351.7 367.1 336.8 377.5 304.9H343.8C340.1 316.8 325.2 323 313.6 323 291.2 323 279.5 309.9 279.5 287.7H379.7C379.8 285.4 380 282.9 380 280.5z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/behance-square.js
// module id = 8r4C
// module chunks = 144